import apiService from "../../api/api.service";
import {
  FilterRequest,
  FiltersResponse,
  GeneralFiltersRequest,
  GeneralFiltersResponse,
} from "./filters.types";

export const fetchFilters = (data: FilterRequest): Promise<FiltersResponse> => {
  return apiService.post<FiltersResponse>("/products/filters", data);
};

export const fetchGeneralFilters = (data: GeneralFiltersRequest): Promise<GeneralFiltersResponse> => {
  return apiService.post<GeneralFiltersResponse>("/general/filters", data);
};
